import { httpClient } from './http-client';
import { API_ENDPOINTS } from '../config/api';

/** Базовая информация о связанной сущности (тип, порода, категория и т.д.) */
export interface NamedRef {
  id: number;
  nameRu: string;
  nameKz: string;
  nameEn: string;
}

export interface FarmRef {
  id: number;
  name: string;
}

export interface LineRef {
  id: number;
  name: string;
  description: string | null;
}

export interface AnimalBasicRef {
  id: string;
  identifierNumber: string;
  name: string | null;
}

/** Животное текущего пользователя (список /animal/my) */
export interface AnimalListItem {
  id: string;
  identifierNumber: string;
  name: string | null;
  birthDate: string | null;
  sex: number | null;
  isBreeding: boolean | null;
  animalType: NamedRef | null;
  breed: NamedRef | null;
  category: NamedRef | null;
  status: NamedRef | null;
  farm: FarmRef | null;
  createdAt: string;
}

/** Полная карточка животного (GET /animal/{id}) */
export interface AnimalDetail {
  id: string;
  identifierNumber: string;
  registrationNumber: string | null;
  inventoryNumber: string | null;
  name: string | null;
  chipNumber: string | null;
  birthDate: string | null;
  birthPlace: string | null;
  birthWeight: number | null;
  weaningDate: string | null;
  weaningWeight: number | null;
  weight12m: number | null;
  isBreeding: boolean | null;
  hasHorns: boolean;
  sex: number | null;
  breedPurity: number | null;
  animalType: NamedRef | null;
  breed: NamedRef | null;
  line: LineRef | null;
  category: NamedRef | null;
  status: NamedRef | null;
  class: NamedRef | null;
  farm: FarmRef | null;
  father: AnimalBasicRef | null;
  mother: AnimalBasicRef | null;
  createdAt: string;
  updatedAt: string | null;
}

export const animalService = {
  /** Все животные текущего пользователя по всем его фермам */
  getMyAnimals(includeDeleted = false): Promise<{ success: boolean; data?: AnimalListItem[]; message?: string }> {
    return httpClient.get<AnimalListItem[]>(`${API_ENDPOINTS.ANIMAL.MY}?includeDeleted=${includeDeleted}`);
  },

  /** Полная информация о животном по идентификатору */
  getAnimalById(id: string): Promise<{ success: boolean; data?: AnimalDetail; message?: string }> {
    return httpClient.get<AnimalDetail>(`${API_ENDPOINTS.ANIMAL.BASE}/${id}`);
  },
};
